import { createElement } from "react";
import { textVariants } from "../text/text.styles";
import { cn } from "../utils";
export function ErrorMessage({ children, className, as = "p", "data-testid": dataTestId, ...props }) {
    return createElement(as, {
        className: cn(textVariants({ variant: "bodySmall", color: "error" }), className),
        "data-testid": dataTestId,
        ...props,
    }, children);
}
//# sourceMappingURL=Error.js.map